/**
 * Procedure Categories and Procedures for DM in Neurology students
 * Extracted with strict evidence from official NMC PDF (Page 5, 8: "Psychomotor domain - Must know skills perform independently")
 */
export const NEUROLOGY_PROCEDURES = {
  "Diagnostic Neurophysiology & Sleep Procedures": [
    "Electroencephalography (EEG) Recording & Interpretation",
    "Video EEG (VEEG) & EEG-Telemetry Monitoring & Interpretation",
    "Nerve Conduction Studies (NCS) & Electromyography (EMG)",
    "Evoked Potentials (VEP, BAER / BAEP, SSEP) Recording & Interpretation",
    "Polysomnography (PSG) & Sleep Titration Interpretation",
  ],
  "Invasive Neurological, Biopsy & Therapeutic Procedures": [
    "Lumbar Puncture, CSF Manometry & CSF Tap Test for NPH",
    "Muscle Biopsy & Nerve Biopsy",
    "Intrathecal Drug Administration (Antispasticity Drugs / Chemotherapy)",
    "Therapeutic Botulinum Toxin (Botox) Injection for Movement Disorders (Blepharospasm, Hemifacial Spasm, Dystonia)",
    "Side Lab CSF Microscopy, Protein & Cellular Analysis",
  ],
  "Neurovascular, Interventional & Critical Care Procedures": [
    "Transcranial Doppler (TCD) & Carotid / Vertebral Color Duplex Sonography",
    "Diagnostic Digital Subtraction Angiography (DSA) & Cerebral Angiography",
    "Intra-Arterial Thrombolysis & Assistance in Mechanical Thrombectomy for Acute Stroke",
    "Endotracheal Intubation, CPAP & Mechanical Ventilation in Neuro-ICU",
    "Central Venous & Peripheral Arterial Cannulation (Arterial Line Placement)",
  ],
};

export const NEUROLOGY_CATEGORIES = Object.keys(NEUROLOGY_PROCEDURES);

export const isDMInNeurologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("neurology") && !d.includes("paediatric") && !d.includes("pediatric") && !d.includes("radiology") && !d.includes("anaesthesia");
};
